import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropPrimaryData } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP, FOOTPRINTING_CROP_PRIMARY_DATA } from "consts";

export const useSubmitFootprintingCropPrimaryData = (farmId: string, year: number, idPairs: Array<{ cropId: string; primaryDataId: string }>) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_PRIMARY_DATA],
      mutationFn: async () =>
        Promise.all(idPairs.map((idPair) => setFootprintingCropPrimaryData({ farmId, year, cropId: idPair.cropId, isSubmitted: true }, idPair.primaryDataId))),
      onSuccess: async () => {
        idPairs.map(async (idPair) => {
          const QKs = [
            [FOOTPRINTING_CROP_PRIMARY_DATA, idPair.primaryDataId, isAdmin],
            [FOOTPRINTING_CROP_PRIMARY_DATA, farmId, idPair.cropId, year, isAdmin],
            [FOOTPRINTING_CROP, farmId, idPair.cropId, year, isAdmin],
          ];
          await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
          await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
        });
      },
    },
    queryClient
  );
};
